module.exports = {
  pagination: {
    of: 'van',
    page: 'Pagina',
    previousPage: 'Vorige pagina',
    nextPage: 'Volgende pagina',
  },
  select: {
    placeholder: 'Selecteer...',
  },
  table: {
    add: 'Toevoegen',
    noTableData: 'Geen gegevens gevonden.',
    subtotal: 'Subtotaal',
  },
};



// WEBPACK FOOTER //
// ./js/lang/nl/components.js